export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'School',
          value: 'School',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Status',
          value: 'isActive',
          filterable: false,
        },
      ],
    },
  },
  read:{
    tabs:[
      // {
      //   key:'Classroom',
      //   label:'classrooms',
      // },
      {
        key:'Info',
        label:'info',
      },
    ],
    table:{
      headers: [
        {
          text: 'School',
          value: 'School',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Status',
          value: 'isActive',
          filterable: false,
        },
        {
          text: 'Created',
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text: 'Last Updated',
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:{
    fields:[
      {
        type:'model',
        key:'schoolId',
        name:'School',
        model:'school',
        optionText:'name',
        optionValue:'id',
        defaultValue:1,
      },
      {
        type:'string',
        key:'name',
        name:'Name',
      },
    ],
    rules:{
      name: [v => !!v || 'Name is required'],
    },
  },
  edit:true,
  delete:true,
}